(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.l-slider').forEach((slider) => {
            const container = slider.querySelector('.slider-container');

            if (!container) return;

            $(container).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                speed: 600,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnHover: false,
                centerMode: true,

                mobileFirst: true,

                prevArrow: $(slider).find('.l-slider-prev'),
                nextArrow: $(slider).find('.l-slider-next'),

                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 7 } },
                    { breakpoint: 992, settings: { slidesToShow: 5 } },
                    { breakpoint: 768, settings: { slidesToShow: 4 } },
                    { breakpoint: 576, settings: { slidesToShow: 3 } },
                    { breakpoint: 467, settings: { slidesToShow: 2 } },
                ],
            });
        });
    });
})(jQuery)
